module.exports = __webpack_public_path__ + "img/pre_ios.e4435b49.png";